import React from 'react';
import { motion } from 'framer-motion';
export function InsidePreview() {
  const previews = ['Contracciones reales vs falsas', 'Señales importantes del recién nacido', 'Cómo entender el llanto del bebé', 'Qué esperar en cada trimestre', 'Cuidados durante el postparto', 'Información explicada de forma simple y visual'];
  return <section className="py-20 md:py-28 bg-sage-light/30" data-id="element-205">
      <div className="max-w-5xl mx-auto px-6 text-center" data-id="element-206">
        <div className="mb-16" data-id="element-207">
          <span className="inline-block text-xs md:text-sm font-bold tracking-[0.3em] text-peach-dark uppercase mb-4" data-id="element-208">
            👀 MIRÁ POR DENTRO
          </span>
          <h2 className="font-serif text-text-dark leading-[1.05] tracking-tight mb-4" style={{
          fontSize: 'clamp(2rem, 5vw, 4rem)'
        }} data-id="element-209">
            Páginas reales del material
          </h2>
          <p className="font-serif italic text-xl text-peach-dark" data-id="element-210">
            Esto es lo que vas a recibir
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6" data-id="element-211">
          {previews.map((preview, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="aspect-[3/4] bg-white rounded-2xl p-6 shadow-sm border border-sage/20 flex flex-col items-center justify-center text-center hover:shadow-lg transition-shadow" data-id="element-212">
              <span className="text-3xl mb-4" data-id="element-213">🌸</span>
              <p className="text-text-dark font-medium leading-snug" data-id="element-214">
                {preview}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}